var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierachy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.466,
    viewBox: "0 0 14 13.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hierachy_1_",
    "data-name": "hierachy (1)",
    d: "M11.868,21.388v-3.26a.675.675,0,0,1,.675-.675h4.915a.676.676,0,0,1,.675.675v3.26a.676.676,0,0,1-.675.675H12.543A.676.676,0,0,1,11.868,21.388Zm-1.5,4.8V24.729a.179.179,0,0,1,.177-.177h4.117v1.634h.677V24.551h4.118a.179.179,0,0,1,.177.177v1.457h.677V24.729a.855.855,0,0,0-.854-.855H15.338V22.741h-.677v1.133H10.544a.855.855,0,0,0-.854.855v1.457Zm6.033.677H13.6a.628.628,0,0,0-.628.628v2.8a.628.628,0,0,0,.628.628h2.8a.628.628,0,0,0,.628-.628v-2.8A.628.628,0,0,0,16.4,26.863Zm-4.972,0h-2.8A.628.628,0,0,0,8,27.491v2.8a.628.628,0,0,0,.628.628h2.8a.628.628,0,0,0,.628-.628v-2.8A.628.628,0,0,0,11.429,26.863Zm9.944,0h-2.8a.628.628,0,0,0-.628.628v2.8a.628.628,0,0,0,.628.628h2.8A.628.628,0,0,0,22,30.293v-2.8A.628.628,0,0,0,21.372,26.863Z",
    transform: "translate(-8 -17.454)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierachy);
export default __webpack_public_path__ + "static/media/hierachy.6d9527d9aaf8eb3a2f0ebc812bf54104.svg";
export { ForwardRef as ReactComponent };